export interface DetectedDienstwagen {
  listenpreis: number | null
  gwvBetrag: number | null
  gwvProzent: number
  entfernungKm: number | null
  bezeichnung: string | null
  gehaltsumwandlung: number | null
}

export interface ParsedPayslip {
  bruttogehalt: number | null
  steuerklasse: number | null
  kirchensteuer: boolean | null
  bundesland: string | null
  krankenversicherungTyp: 'GKV' | 'PKV' | null
  kvZusatzbeitrag: number | null
  anzahlKinder: number | null
  kinderfreibetrag: number | null
  bavBeitragAN: number | null
  bavBeitragAG: number | null
  pkBeitrag: number | null
  dienstwagen: DetectedDienstwagen[]
  firmenfitnessBeitrag: number | null
  fahrradLeasingVorhanden: boolean | null
  fahrradListenpreis: number | null
  fahrradGwvProzent: number | null
  fahrradGehaltsumwandlung: number | null
  pkvMonatsbeitragKV: number | null
  pkvMonatsbeitragPV: number | null
  pkvAGZuschussKV: number | null
  pkvAGZuschussPV: number | null
}

import { authenticatedFetch } from '../../../shared/utils/authenticatedFetch'

const PROXY_URL =
  import.meta.env.VITE_PROXY_URL ||
  'https://proxy-prod-people-520260363689.europe-west3.run.app'

export async function parsePayslip(file: File): Promise<ParsedPayslip> {
  const base64 = await fileToBase64(file)
  const mediaType = file.type || (file.name.endsWith('.pdf') ? 'application/pdf' : 'image/png')

  const response = await authenticatedFetch(`${PROXY_URL}/api/jobauto/parse-payslip`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ fileData: base64, mediaType, fileName: file.name }),
  })

  const parsed: ParsedPayslip = await response.json()
  if (!Array.isArray(parsed.dienstwagen)) {
    parsed.dienstwagen = []
  }
  return parsed
}

function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => {
      const result = reader.result as string
      resolve(result.split(',')[1])
    }
    reader.onerror = reject
    reader.readAsDataURL(file)
  })
}
